export default __webpack_public_path__ + "images/logo-eriflex.svg?fdc8129ea1e621e701478149796478f8";